import React from 'react';
import { GlobalStyles, SYS_COLOR_CANVAS_DEFAULT_DARK, SYS_COLOR_CANVAS_INVERTED_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT, SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_DARK, GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_LIGHT, ThemeProvider, GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_LIGHT, } from '@oneaudi/unified-web-common';
import { GlobalStyles as AlphaGlobalStyles, SYS_COLOR_CANVAS_200_DARK, SYS_COLOR_CANVAS_200_LIGHT, SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_DARK, SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_LIGHT, SYS_COLOR_FOREGROUND_ON_SIGNAL_100_DARK, SYS_COLOR_TEXT_HEADLINE_DEFAULT_LIGHT, } from '@oneaudi/unified-web-alpha-common';
export const DynamicThemeProviderWrapper = ({ isDemo, children }) => (React.createElement(ThemeProvider, { theme: isDemo
        ? {
            iconBasePath: 'icons',
            name: dynamicStylingHelper('light', 'dark'),
        }
        : {
            name: dynamicStylingHelper('light', 'dark'),
        } }, children));
export const DynamicGlobalStyles = () => {
    return process.env.IS_LEGACY || process.env.IS_LEGACY === undefined ? (React.createElement(GlobalStyles, null)) : (React.createElement(AlphaGlobalStyles, { hasGlobalBackgroundColor: true, themeName: "dark" }));
};
export const GetSafeColorDesignToken = (color) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        const legacyTokens = {
            dark: SYS_COLOR_CANVAS_DEFAULT_DARK,
            inverted: SYS_COLOR_CANVAS_INVERTED_DARK,
            'interactive-light': SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
            'interactive-dark': SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK,
            INDICATOR_DEFAULT_DARK: SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_DARK,
            HEADLINE_ORDER1_LIGHT: GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_LIGHT,
            'shadow-l1': GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_LIGHT,
        };
        return legacyTokens[color];
    }
    const alphaTokens = {
        dark: SYS_COLOR_CANVAS_200_DARK,
        inverted: SYS_COLOR_CANVAS_200_LIGHT,
        'interactive-light': SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_LIGHT,
        'interactive-dark': SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_DARK,
        INDICATOR_DEFAULT_DARK: SYS_COLOR_FOREGROUND_ON_SIGNAL_100_DARK,
        HEADLINE_ORDER1_LIGHT: SYS_COLOR_TEXT_HEADLINE_DEFAULT_LIGHT,
        'shadow-l1': 'none',
    };
    return alphaTokens[color];
};
export const DynamicWrapper = ({ children, LegacyWrapperFc, AlphaWrapperFc }) => {
    if (!children) {
        return null;
    }
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        if (LegacyWrapperFc) {
            return React.createElement(LegacyWrapperFc, null, children);
        }
        return React.createElement(React.Fragment, null, children);
    }
    if (AlphaWrapperFc) {
        return React.createElement(AlphaWrapperFc, null, children);
    }
    return React.createElement(React.Fragment, null, children);
};
export const DynamicComponent = ({ legacy, alpha, }) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return legacy;
    }
    return alpha;
};
export function dynamicStyling({ legacy, alpha }) {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return legacy !== null && legacy !== void 0 ? legacy : (typeof alpha === 'string' ? '' : legacy);
    }
    return alpha !== null && alpha !== void 0 ? alpha : (typeof legacy === 'string' ? '' : alpha);
}
export function dynamicStylingHelper(unifiedStylingInput, alphaStylingInput) {
    return dynamicStyling({ legacy: unifiedStylingInput, alpha: alphaStylingInput });
}
export const getDesignLibrary = (props) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return {
            '@oneaudi/unified-web-common': (props === null || props === void 0 ? void 0 : props.unifiedWebCommonVersion) || '*',
        };
    }
    return {
        '@oneaudi/unified-web-alpha-common': (props === null || props === void 0 ? void 0 : props.unifiedWebAlphaCommonVersion) || '*',
    };
};
